import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { selectCurrentOrganization } from "@/modules/organizations/store/organizationSlice"
import { getCallQuota } from "../../applicants-service"

export function callQuotaQueryKey(organizationId: string | undefined) {
  return ["call-quota", organizationId] as const
}

export function useCallQuota() {
  const currentOrganization = useSelector(selectCurrentOrganization)

  return useQuery({
    queryKey: callQuotaQueryKey(currentOrganization?.id),
    queryFn: () => getCallQuota(currentOrganization!.id),
    enabled: !!currentOrganization?.id,
    staleTime: 10_000,
  })
}

export function useInvalidateCallQuota() {
  const queryClient = useQueryClient()
  const currentOrganization = useSelector(selectCurrentOrganization)

  return () =>
    queryClient.invalidateQueries({
      queryKey: callQuotaQueryKey(currentOrganization?.id),
    })
}
